import React from 'react';
import './Header.css';
import { IoChevronBackOutline } from "react-icons/io5";
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <section className="hero_container">
      <div className="container">
        <div className="content_container">
          <h1>
          <span>الأهـــــــــرام</span>    شركة 
          </h1>
          <h3>للتوظيف وإلحاق العمالة المصرية بالخارج</h3>
          <p>مرخص من وزارة القوى العاملة والهجرة برقم 128</p>

          <div className="hero-btns">
            <Link to='/owner' className='btn btn-custom owner'>
              <IoChevronBackOutline />
              صاحب العمل
            </Link>
            <Link to='/applier' className='btn btn-custom applier'>
              <IoChevronBackOutline />
              باحث عن وظيفة
            </Link>
          </div>
          
        
        </div>
      </div>
    </section>
  );
};

export default Header;